import React from 'react'
import PropTypes from 'prop-types'
import { ActionMenu } from 'components'
import {
  ServicesAgreementStatus,
  SigningMethod,
  CombinedServiceAgreementStatus,
} from 'config/automatic-rollovers'

const propTypes = {
  showSigningActions: PropTypes.bool,
  portalAgreementStatus: PropTypes.string,
  signingMethod: PropTypes.string,
  actionItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  actionMenuLabel: PropTypes.string.isRequired,
  onInitiate: PropTypes.func.isRequired,
  onUploadSignedAgreement: PropTypes.func.isRequired,
  onResendDocusignEmail: PropTypes.func.isRequired,
  onDownloadAgreement: PropTypes.func.isRequired,
  initiateLabel: PropTypes.string.isRequired,
  uploadSignedAgreementLabel: PropTypes.string.isRequired,
  resendDocusignEmailLabel: PropTypes.string.isRequired,
  downloadAgreementLabel: PropTypes.string.isRequired,
}

const defaultProps = {
  showSigningActions: true,
  portalAgreementStatus: null,
  signingMethod: null,
}
function AgreementDetailsActions({
  showSigningActions,
  portalAgreementStatus,
  signingMethod,
  actionItems,
  actionMenuLabel,
  onInitiate,
  onUploadSignedAgreement,
  onResendDocusignEmail,
  onDownloadAgreement,
  initiateLabel,
  uploadSignedAgreementLabel,
  resendDocusignEmailLabel,
  downloadAgreementLabel,
}) {
  return (
    <div className="services-agreements-actions">
      {(portalAgreementStatus === ServicesAgreementStatus.COMPLETED ||
        portalAgreementStatus ===
          CombinedServiceAgreementStatus.COMBINED_COMPLETED) && (
        <>
          <ActionMenu items={actionItems} ariaLabel={actionMenuLabel} />
          <button type="button" className="button-primary" onClick={onInitiate}>
            {initiateLabel}
          </button>
        </>
      )}
      {(portalAgreementStatus === ServicesAgreementStatus.PENDING_SIGNATURES ||
        portalAgreementStatus ===
          CombinedServiceAgreementStatus.COMBINED_PENDING_SIGNATURES) &&
        showSigningActions &&
        signingMethod === SigningMethod.GENERATE_DOCUMENT && (
          <button
            type="button"
            onClick={onUploadSignedAgreement}
            className="button-text"
          >
            {uploadSignedAgreementLabel}
          </button>
        )}
      {(portalAgreementStatus === ServicesAgreementStatus.PENDING_SIGNATURES ||
        portalAgreementStatus ===
          CombinedServiceAgreementStatus.COMBINED_PENDING_SIGNATURES) &&
        showSigningActions &&
        signingMethod === SigningMethod.ELECTRONIC && (
          <button
            type="button"
            onClick={onResendDocusignEmail}
            className="button-text"
          >
            {resendDocusignEmailLabel}
          </button>
        )}
      {(portalAgreementStatus === ServicesAgreementStatus.PENDING_SIGNATURES ||
        portalAgreementStatus ===
          CombinedServiceAgreementStatus.COMBINED_PENDING_SIGNATURES) && (
        <button
          type="button"
          onClick={onDownloadAgreement}
          className="button-primary"
        >
          {downloadAgreementLabel}
        </button>
      )}
    </div>
  )
}

AgreementDetailsActions.propTypes = propTypes
AgreementDetailsActions.defaultProps = defaultProps

export default AgreementDetailsActions
